var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhiding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h11M8 5v9.5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5l.354-.354a.5.5 0 00-.708 0L8 5zM2.896 9.396a.5.5 0 00.708.708l-.708-.708zm9.5.708a.5.5 0 00.708-.708l-.708.708zm-4.75-5.458l-4.5 4.5.708.708 4.5-4.5-.708-.708zm-4.5 4.5l-.25.25.708.708.25-.25-.708-.708zm9.958.25l-4.75-4.75-.708.708 4.75 4.75.708-.708z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zhiding.1ed2a70e.svg";
export { SvgTongyongZhiding as ReactComponent };